import { __awaiter } from "tslib";
import { CACHE_OPTIONS_METADATA } from './injectCache';
const defaultOptions = {
    ttl: 5000,
};
export const cache = (cacheKey, options = defaultOptions) => {
    options = Object.assign(Object.assign({}, defaultOptions), options);
    return (target, _, descriptor) => {
        const originalMethod = descriptor.value;
        const cacheOptions = Reflect.getMetadata(CACHE_OPTIONS_METADATA, target.constructor);
        descriptor.value = function (...args) {
            return __awaiter(this, void 0, void 0, function* () {
                const finalCacheKey = args.length === 0 ? cacheKey : `${cacheKey}-${args.join('-')}`;
                const cacheResult = yield this[cacheOptions.memberName].get(finalCacheKey);
                if (cacheResult) {
                    return cacheResult;
                }
                return originalMethod.apply(this, args).then((result) => {
                    this[cacheOptions.memberName].set(finalCacheKey, result, options.ttl);
                    return result;
                });
            });
        };
    };
};
